import { render, staticRenderFns } from "./LocalityUserCard.vue?vue&type=template&id=40e30ada"
import script from "./LocalityUserCard.vue?vue&type=script&lang=js"
export * from "./LocalityUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports